




































































import { Vue, Component, Prop } from "vue-property-decorator";

interface RegulationOptions {
  vesselId: number;
  year: number;
  totalComplianceBalance: number;
  totalEmittedCo2: number;
  totalEmittedN2O: number;
  totalEmittedCh4: number;
  totalEuas: number;
  totalPenalty: number;
  avgGhgIntensity: number;
  requiredGhgIntensity: number;
  diffinGhgIntensity: number;
}

@Component({})
export default class RegulationCard extends Vue {
  @Prop() options!: RegulationOptions;
  @Prop({ type: Boolean, default: false }) loading!: Boolean;
  @Prop() title!: string;
  @Prop() type!: string;

  //  @Getters
  get CardData(): any[] | undefined {
    if (!this.options) return;
    switch (this.type) {
      case "mrv":
        return [
          {
            text: "CO2 Emissions",
            tooltip: "Tooltip text placeholder",
            value: this.options.totalEmittedCo2.toFixed(1),
            unit: "t",
          },
          {
            text: "N20 Emissions",
            tooltip: "Tooltip text placeholder",
            value: this.options.totalEmittedN2O.toFixed(1),
            unit: "t",
          },
          {
            text: "CH4 Emissions",
            tooltip: "Tooltip text placeholder",
            value: this.options.totalEmittedCh4.toFixed(1),
            unit: "t",
          },
        ];
      case "ets":
        return [
          {
            text: "EUAs",
            tooltip: "Tooltip text placeholder",
            value: this.options.totalEuas.toFixed(1),
          },
        ];
      case "fuel":
        return [
          {
            text: "Avg. GHG Intensity",
            tooltip: "Tooltip text placeholder",
            value: this.options.avgGhgIntensity.toFixed(2),
            dataType: "avgGhgIntensity",
            unit: "gCO<sub>2</sub> e/MJ",
          },
          {
            text: "Required GHG Intensity",
            tooltip: "Tooltip text placeholder",
            value: this.options.requiredGhgIntensity.toFixed(2),
            unit: "gCO<sub>2</sub> e/MJ",
          },
          {
            text: "Compliance Balance",
            tooltip: "Tooltip text placeholder",
            value: this.options.totalComplianceBalance.toFixed(2),
            unit: "gCO<sub>2</sub>e",
          },
          {
            text: "Penalty",
            tooltip: "Tooltip text placeholder",
            value: this.options.totalPenalty.toFixed(2),
            unit: "€",
          },
        ];
      default:
        return [];
    }
  }

  isValueHighlighted(dataType: string): boolean {
    if (!dataType) return false;
    if (this.type === "fuel" && dataType === "avgGhgIntensity") return this.options.avgGhgIntensity > this.options.requiredGhgIntensity;
    return false;
  }

  get skeletonStructure(): object {
    return { "table-row": "table-cell@1" };
  }
}
